import { ingestionConstants } from "../constants/ingestion.constants";

export function ingestion(state = {}, action) {
  switch (action.type) {
    case ingestionConstants.INGESTION_DETAIL_REQUEST:
      return {
        ...state,
        run: null,
      };
    case ingestionConstants.INGESTION_DETAIL_SUCCESS:
      return {
        ...state,
        run: action.response,
      };
    case ingestionConstants.INGESTION_CLASSIFY_REQUEST:
      return {
        ...state,
        isClassifying: true,
        classifications: null,
      };
    case ingestionConstants.INGESTION_CLASSIFY_SUCCESS:
      return {
        ...state,
        isClassifying: false,
        classifications: action.response,
      };
    case ingestionConstants.INGESTION_CLASSIFY_FAILURE:
      return {
        ...state,
        isClassifying: false,
        classifications: null,
      };
    default:
      return state;
  }
}
